// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { companyLogoItem } from "@eisinc/App/SharedStyles/GeneralStyles";
import { orderInformationStyles } from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderInformationStyles.companyLogoItem = {
    ...companyLogoItem,
};

orderInformationStyles.OrderInformationGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

orderInformationStyles.infoSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        ${({ showBorderBottom }: any) =>
            showBorderBottom &&
            ` padding-bottom: 16px;
        border-bottom: 1px solid ${getSystemColor("common.border")};`};

        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

orderInformationStyles.billingInformationSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

orderInformationStyles.shippingInfoSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

orderInformationStyles.headingSection = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
        grid-column: 1 / -1;
    `,
};

orderInformationStyles.fullWidthColumn = {
    css: css`
        grid-column: 1 / -1;
    `,
};

orderInformationStyles.messageText = {
    size: fontConfig.singleLineSmall.size,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    weight: fontConfig.weight.regular,
    css: css`
        & > ${TypographyStyle} {
            color: inherit;
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};

orderInformationStyles.createGuestAccountSection = {
    css: css`
        background-color: ${color("common.ui2")};
        padding: 12px;
        & > div {
            display: flex;
            flex-direction: column;
            gap: 12px;
            button {
                width: fit-content;
            }
        }
    `,
};

orderInformationStyles.guestAccountTitle = { variant: "h4", css: css`margin-bottom:0;` }

orderInformationStyles.guestAccountMessage = { ...fontConfig.regular }
